import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-sellers-header',
  templateUrl: './sellers-header.component.html',
  styleUrls: ['./sellers-header.component.scss'],
})
export class SellersHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();
}
